module.exports = __webpack_public_path__ + "static/media/trendingmeanreverting.f38fc56a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/SVGs/trendingmeanreverting.svg
// module id = 186
// module chunks = 0